//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AppTextClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getAppTexts(): Promise<AppTexts> {
    let url_ = this.baseUrl + '/api/AppText';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAppTexts(_response);
    });
  }

  protected processGetAppTexts(response: Response): Promise<AppTexts> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AppTexts.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<AppTexts>(null as any);
  }
}

export class AssistEventClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  index(request: any): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/AssistEvent';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processIndex(_response);
    });
  }

  protected processIndex(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }

  index2(name: string | null | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/AssistEvent?';
    if (name !== undefined && name !== null)
      url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processIndex2(_response);
    });
  }

  protected processIndex2(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }
}

export class CaseClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(): Promise<Case[]> {
    let url_ = this.baseUrl + '/api/Case';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGet(_response);
    });
  }

  protected processGet(response: Response): Promise<Case[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(Case.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Case[]>(null as any);
  }
}

export class CustomerAdminClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getCustomers(): Promise<CustomerPreviewModel[]> {
    let url_ = this.baseUrl + '/api/CustomerAdmin';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCustomers(_response);
    });
  }

  protected processGetCustomers(
    response: Response
  ): Promise<CustomerPreviewModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(CustomerPreviewModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CustomerPreviewModel[]>(null as any);
  }

  createCustomer(
    repairshopId: number | undefined,
    displayName: string | null | undefined,
    orgNr: string | null | undefined,
    statisticsDistanceInKm: number | undefined
  ): Promise<CustomerPreviewModel> {
    let url_ = this.baseUrl + '/api/CustomerAdmin?';
    if (repairshopId === null)
      throw new Error("The parameter 'repairshopId' cannot be null.");
    else if (repairshopId !== undefined)
      url_ += 'repairshopId=' + encodeURIComponent('' + repairshopId) + '&';
    if (displayName !== undefined && displayName !== null)
      url_ += 'displayName=' + encodeURIComponent('' + displayName) + '&';
    if (orgNr !== undefined && orgNr !== null)
      url_ += 'orgNr=' + encodeURIComponent('' + orgNr) + '&';
    if (statisticsDistanceInKm === null)
      throw new Error("The parameter 'statisticsDistanceInKm' cannot be null.");
    else if (statisticsDistanceInKm !== undefined)
      url_ +=
        'statisticsDistanceInKm=' +
        encodeURIComponent('' + statisticsDistanceInKm) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateCustomer(_response);
    });
  }

  protected processCreateCustomer(
    response: Response
  ): Promise<CustomerPreviewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerPreviewModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CustomerPreviewModel>(null as any);
  }

  getCustomer(customerId: number): Promise<CustomerModel> {
    let url_ = this.baseUrl + '/api/CustomerAdmin/{customerId}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCustomer(_response);
    });
  }

  protected processGetCustomer(response: Response): Promise<CustomerModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CustomerModel>(null as any);
  }

  updateCustomer(
    customerId: number,
    updatedModel: CustomerModel
  ): Promise<CustomerModel> {
    let url_ = this.baseUrl + '/api/CustomerAdmin/{customerId}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updatedModel);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateCustomer(_response);
    });
  }

  protected processUpdateCustomer(response: Response): Promise<CustomerModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CustomerModel>(null as any);
  }

  removeCustomerStation(customerId: number, stationId: number): Promise<void> {
    let url_ =
      this.baseUrl + '/api/CustomerAdmin/{customerId}/stations/{stationId}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveCustomerStation(_response);
    });
  }

  protected processRemoveCustomerStation(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  addCustomerStation(
    customerId: number,
    stationId: number
  ): Promise<StationPreviewModel> {
    let url_ = this.baseUrl + '/api/CustomerAdmin/{customerId}/stations';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(stationId);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddCustomerStation(_response);
    });
  }

  protected processAddCustomerStation(
    response: Response
  ): Promise<StationPreviewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StationPreviewModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationPreviewModel>(null as any);
  }
}

export class InventoryClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getAllInventories(): Promise<InventoryModel[]> {
    let url_ = this.baseUrl + '/api/Inventory/list';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllInventories(_response);
    });
  }

  protected processGetAllInventories(
    response: Response
  ): Promise<InventoryModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(InventoryModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryModel[]>(null as any);
  }

  getInventoryDetails(inventoryId: number): Promise<InventoryModel> {
    let url_ = this.baseUrl + '/api/Inventory/{inventoryId}';
    if (inventoryId === undefined || inventoryId === null)
      throw new Error("The parameter 'inventoryId' must be defined.");
    url_ = url_.replace('{inventoryId}', encodeURIComponent('' + inventoryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInventoryDetails(_response);
    });
  }

  protected processGetInventoryDetails(
    response: Response
  ): Promise<InventoryModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = InventoryModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryModel>(null as any);
  }

  update(
    inventoryId: number,
    request: UpdateInventoryRequest
  ): Promise<InventoryModel> {
    let url_ = this.baseUrl + '/api/Inventory/{inventoryId}';
    if (inventoryId === undefined || inventoryId === null)
      throw new Error("The parameter 'inventoryId' must be defined.");
    url_ = url_.replace('{inventoryId}', encodeURIComponent('' + inventoryId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<InventoryModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = InventoryModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryModel>(null as any);
  }

  search(request: InventorySearchRequest): Promise<InventoryModel[]> {
    let url_ = this.baseUrl + '/api/Inventory/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSearch(_response);
    });
  }

  protected processSearch(response: Response): Promise<InventoryModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(InventoryModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryModel[]>(null as any);
  }

  bookingSearch(
    repairShopId: number | undefined,
    registrationNumber: string | null | undefined
  ): Promise<InventoryModel[]> {
    let url_ = this.baseUrl + '/api/Inventory/booking-search?';
    if (repairShopId === null)
      throw new Error("The parameter 'repairShopId' cannot be null.");
    else if (repairShopId !== undefined)
      url_ += 'repairShopId=' + encodeURIComponent('' + repairShopId) + '&';
    if (registrationNumber !== undefined && registrationNumber !== null)
      url_ +=
        'registrationNumber=' +
        encodeURIComponent('' + registrationNumber) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processBookingSearch(_response);
    });
  }

  protected processBookingSearch(
    response: Response
  ): Promise<InventoryModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(InventoryModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryModel[]>(null as any);
  }

  getComments(inventoryId: number): Promise<InventoryCommentModel[]> {
    let url_ = this.baseUrl + '/api/Inventory/{inventoryId}/comments';
    if (inventoryId === undefined || inventoryId === null)
      throw new Error("The parameter 'inventoryId' must be defined.");
    url_ = url_.replace('{inventoryId}', encodeURIComponent('' + inventoryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetComments(_response);
    });
  }

  protected processGetComments(
    response: Response
  ): Promise<InventoryCommentModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(InventoryCommentModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryCommentModel[]>(null as any);
  }

  saveComment(
    inventoryId: number,
    comment: InventoryCommentModel
  ): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Inventory/{inventoryId}/comments';
    if (inventoryId === undefined || inventoryId === null)
      throw new Error("The parameter 'inventoryId' must be defined.");
    url_ = url_.replace('{inventoryId}', encodeURIComponent('' + inventoryId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(comment);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSaveComment(_response);
    });
  }

  protected processSaveComment(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }

  create(request: CreateInventoryRequest): Promise<InventoryModel> {
    let url_ = this.baseUrl + '/api/Inventory';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(response: Response): Promise<InventoryModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = InventoryModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InventoryModel>(null as any);
  }

  createTransfer(
    inventoryId: number,
    createInventoryTransferRequest: CreateInventoryTransferRequest
  ): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Inventory/{inventoryId}/transfer';
    if (inventoryId === undefined || inventoryId === null)
      throw new Error("The parameter 'inventoryId' must be defined.");
    url_ = url_.replace('{inventoryId}', encodeURIComponent('' + inventoryId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createInventoryTransferRequest);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateTransfer(_response);
    });
  }

  protected processCreateTransfer(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }

  deleteTransfer(
    inventoryId: number,
    transferId: number
  ): Promise<FileResponse | null> {
    let url_ =
      this.baseUrl + '/api/Inventory/{inventoryId}/transfer/{transferId}';
    if (inventoryId === undefined || inventoryId === null)
      throw new Error("The parameter 'inventoryId' must be defined.");
    url_ = url_.replace('{inventoryId}', encodeURIComponent('' + inventoryId));
    if (transferId === undefined || transferId === null)
      throw new Error("The parameter 'transferId' must be defined.");
    url_ = url_.replace('{transferId}', encodeURIComponent('' + transferId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteTransfer(_response);
    });
  }

  protected processDeleteTransfer(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }
}

export class NotificationClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  index(id: string): Promise<AssignmentModel> {
    let url_ = this.baseUrl + '/api/Notification/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processIndex(_response);
    });
  }

  protected processIndex(response: Response): Promise<AssignmentModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AssignmentModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<AssignmentModel>(null as any);
  }
}

export class NotificationReceiversClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(): Promise<NotificationReceiverDto[]> {
    let url_ = this.baseUrl + '/api/NotificationReceivers';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGet(_response);
    });
  }

  protected processGet(response: Response): Promise<NotificationReceiverDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(NotificationReceiverDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<NotificationReceiverDto[]>(null as any);
  }

  create(
    notificationReceiver: NotificationReceiverDto
  ): Promise<NotificationReceiverDto> {
    let url_ = this.baseUrl + '/api/NotificationReceivers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notificationReceiver);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreate(_response);
    });
  }

  protected processCreate(
    response: Response
  ): Promise<NotificationReceiverDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = NotificationReceiverDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<NotificationReceiverDto>(null as any);
  }

  update(
    notificationReceiverId: number,
    notificationReceiver: NotificationReceiverDto
  ): Promise<void> {
    let url_ =
      this.baseUrl + '/api/NotificationReceivers/{notificationReceiverId}';
    if (notificationReceiverId === undefined || notificationReceiverId === null)
      throw new Error(
        "The parameter 'notificationReceiverId' must be defined."
      );
    url_ = url_.replace(
      '{notificationReceiverId}',
      encodeURIComponent('' + notificationReceiverId)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(notificationReceiver);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdate(_response);
    });
  }

  protected processUpdate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  delete(notificationReceiverId: number): Promise<void> {
    let url_ =
      this.baseUrl + '/api/NotificationReceivers/{notificationReceiverId}';
    if (notificationReceiverId === undefined || notificationReceiverId === null)
      throw new Error(
        "The parameter 'notificationReceiverId' must be defined."
      );
    url_ = url_.replace(
      '{notificationReceiverId}',
      encodeURIComponent('' + notificationReceiverId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDelete(_response);
    });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  testReport(): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/NotificationReceivers/test-report';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processTestReport(_response);
    });
  }

  protected processTestReport(
    response: Response
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse | null>(null as any);
  }
}

export class OrderClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  post(order: WebOrder): Promise<void> {
    let url_ = this.baseUrl + '/api/Order';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(order);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPost(_response);
    });
  }

  protected processPost(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getSentOrders(): Promise<WebOrder[]> {
    let url_ = this.baseUrl + '/api/Order/get-sent-orders';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSentOrders(_response);
    });
  }

  protected processGetSentOrders(response: Response): Promise<WebOrder[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(WebOrder.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<WebOrder[]>(null as any);
  }
}

export class RepairShopInfoClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getUsersCurrentCustomerRepairshopInfo(): Promise<RepairshopInfo> {
    let url_ = this.baseUrl + '/api/RepairShopInfo';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUsersCurrentCustomerRepairshopInfo(_response);
    });
  }

  protected processGetUsersCurrentCustomerRepairshopInfo(
    response: Response
  ): Promise<RepairshopInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RepairshopInfo.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<RepairshopInfo>(null as any);
  }

  getUsersRepairShopInfoWithCustomerName(): Promise<
    RepairShopInfoWithCustomerName[]
  > {
    let url_ = this.baseUrl + '/api/RepairShopInfo/allWithCustomerName';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUsersRepairShopInfoWithCustomerName(_response);
    });
  }

  protected processGetUsersRepairShopInfoWithCustomerName(
    response: Response
  ): Promise<RepairShopInfoWithCustomerName[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(RepairShopInfoWithCustomerName.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<RepairShopInfoWithCustomerName[]>(null as any);
  }

  getStations(): Promise<StationModel[]> {
    let url_ = this.baseUrl + '/api/RepairShopInfo/stations';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStations(_response);
    });
  }

  protected processGetStations(response: Response): Promise<StationModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(StationModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationModel[]>(null as any);
  }
}

export class StagingLotClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  get(stagingLotId: number): Promise<StagingLotModel> {
    let url_ = this.baseUrl + '/api/StagingLot/{stagingLotId}';
    if (stagingLotId === undefined || stagingLotId === null)
      throw new Error("The parameter 'stagingLotId' must be defined.");
    url_ = url_.replace(
      '{stagingLotId}',
      encodeURIComponent('' + stagingLotId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGet(_response);
    });
  }

  protected processGet(response: Response): Promise<StagingLotModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StagingLotModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StagingLotModel>(null as any);
  }

  getStagingLotsByGroupId(
    stagingLotGroupId: number
  ): Promise<StagingLotModel[]> {
    let url_ =
      this.baseUrl + '/api/StagingLot/GetByGroupId/{stagingLotGroupId}';
    if (stagingLotGroupId === undefined || stagingLotGroupId === null)
      throw new Error("The parameter 'stagingLotGroupId' must be defined.");
    url_ = url_.replace(
      '{stagingLotGroupId}',
      encodeURIComponent('' + stagingLotGroupId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStagingLotsByGroupId(_response);
    });
  }

  protected processGetStagingLotsByGroupId(
    response: Response
  ): Promise<StagingLotModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(StagingLotModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StagingLotModel[]>(null as any);
  }

  createTimeSlot(
    stagingLotId: number,
    request: StagingLotTimeSlotGroupModel
  ): Promise<StagingLotModel> {
    let url_ = this.baseUrl + '/api/StagingLot/{stagingLotId}/time-slot';
    if (stagingLotId === undefined || stagingLotId === null)
      throw new Error("The parameter 'stagingLotId' must be defined.");
    url_ = url_.replace(
      '{stagingLotId}',
      encodeURIComponent('' + stagingLotId)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateTimeSlot(_response);
    });
  }

  protected processCreateTimeSlot(
    response: Response
  ): Promise<StagingLotModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StagingLotModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StagingLotModel>(null as any);
  }

  updateTimeSlot(
    stagingLotId: number,
    request: StagingLotTimeSlotGroupModel
  ): Promise<StagingLotModel> {
    let url_ = this.baseUrl + '/api/StagingLot/{stagingLotId}/time-slot';
    if (stagingLotId === undefined || stagingLotId === null)
      throw new Error("The parameter 'stagingLotId' must be defined.");
    url_ = url_.replace(
      '{stagingLotId}',
      encodeURIComponent('' + stagingLotId)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateTimeSlot(_response);
    });
  }

  protected processUpdateTimeSlot(
    response: Response
  ): Promise<StagingLotModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StagingLotModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StagingLotModel>(null as any);
  }

  deleteTimeSlot(
    stagingLotId: number,
    timeSlotId: number
  ): Promise<StagingLotModel> {
    let url_ =
      this.baseUrl + '/api/StagingLot/{stagingLotId}/time-slot/{timeSlotId}';
    if (stagingLotId === undefined || stagingLotId === null)
      throw new Error("The parameter 'stagingLotId' must be defined.");
    url_ = url_.replace(
      '{stagingLotId}',
      encodeURIComponent('' + stagingLotId)
    );
    if (timeSlotId === undefined || timeSlotId === null)
      throw new Error("The parameter 'timeSlotId' must be defined.");
    url_ = url_.replace('{timeSlotId}', encodeURIComponent('' + timeSlotId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteTimeSlot(_response);
    });
  }

  protected processDeleteTimeSlot(
    response: Response
  ): Promise<StagingLotModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StagingLotModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StagingLotModel>(null as any);
  }
}

export class StationAdminClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getStations(): Promise<StationPreviewModel[]> {
    let url_ = this.baseUrl + '/api/StationAdmin';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStations(_response);
    });
  }

  protected processGetStations(
    response: Response
  ): Promise<StationPreviewModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(StationPreviewModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationPreviewModel[]>(null as any);
  }

  createStation(
    name: string | null | undefined,
    zipCode: string | null | undefined,
    postAddress: string | null | undefined
  ): Promise<StationPreviewModel> {
    let url_ = this.baseUrl + '/api/StationAdmin?';
    if (name !== undefined && name !== null)
      url_ += 'name=' + encodeURIComponent('' + name) + '&';
    if (zipCode !== undefined && zipCode !== null)
      url_ += 'zipCode=' + encodeURIComponent('' + zipCode) + '&';
    if (postAddress !== undefined && postAddress !== null)
      url_ += 'postAddress=' + encodeURIComponent('' + postAddress) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateStation(_response);
    });
  }

  protected processCreateStation(
    response: Response
  ): Promise<StationPreviewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StationPreviewModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationPreviewModel>(null as any);
  }

  getStation(stationId: number): Promise<StationModel> {
    let url_ = this.baseUrl + '/api/StationAdmin/{stationId}';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStation(_response);
    });
  }

  protected processGetStation(response: Response): Promise<StationModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StationModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationModel>(null as any);
  }

  updateStation(
    stationId: number,
    updateModel: StationModel
  ): Promise<StationModel> {
    let url_ = this.baseUrl + '/api/StationAdmin/{stationId}';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateModel);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateStation(_response);
    });
  }

  protected processUpdateStation(response: Response): Promise<StationModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StationModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationModel>(null as any);
  }

  deleteStation(stationId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/StationAdmin/{stationId}';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteStation(_response);
    });
  }

  protected processDeleteStation(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  addTower(stationId: number, tower: TowerModel): Promise<TowerModel> {
    let url_ = this.baseUrl + '/api/StationAdmin/{stationId}/towers';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(tower);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddTower(_response);
    });
  }

  protected processAddTower(response: Response): Promise<TowerModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TowerModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<TowerModel>(null as any);
  }

  updateTower(
    stationId: number,
    towerId: number,
    tower: TowerModel
  ): Promise<TowerModel> {
    let url_ = this.baseUrl + '/api/StationAdmin/{stationId}/towers/{towerId}';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    if (towerId === undefined || towerId === null)
      throw new Error("The parameter 'towerId' must be defined.");
    url_ = url_.replace('{towerId}', encodeURIComponent('' + towerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(tower);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateTower(_response);
    });
  }

  protected processUpdateTower(response: Response): Promise<TowerModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = TowerModel.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<TowerModel>(null as any);
  }

  deleteTower(stationId: number, towerId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/StationAdmin/{stationId}/towers/{towerId}';
    if (stationId === undefined || stationId === null)
      throw new Error("The parameter 'stationId' must be defined.");
    url_ = url_.replace('{stationId}', encodeURIComponent('' + stationId));
    if (towerId === undefined || towerId === null)
      throw new Error("The parameter 'towerId' must be defined.");
    url_ = url_.replace('{towerId}', encodeURIComponent('' + towerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteTower(_response);
    });
  }

  protected processDeleteTower(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class StationClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getAllStations(): Promise<StationPreviewModel[]> {
    let url_ = this.baseUrl + '/api/Station';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllStations(_response);
    });
  }

  protected processGetAllStations(
    response: Response
  ): Promise<StationPreviewModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(StationPreviewModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StationPreviewModel[]>(null as any);
  }
}

export class StatisticsClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  clearStatistics(): Promise<string> {
    let url_ = this.baseUrl + '/api/Statistics/clear';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processClearStatistics(_response);
    });
  }

  protected processClearStatistics(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  get(): Promise<CustomerStatistics> {
    let url_ = this.baseUrl + '/api/Statistics';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGet(_response);
    });
  }

  protected processGet(response: Response): Promise<CustomerStatistics> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerStatistics.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CustomerStatistics>(null as any);
  }
}

export class UserAdminClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getUsers(): Promise<UserInfo[]> {
    let url_ = this.baseUrl + '/api/UserAdmin';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUsers(_response);
    });
  }

  protected processGetUsers(response: Response): Promise<UserInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(UserInfo.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserInfo[]>(null as any);
  }

  getUser(userId: string | null): Promise<UserInfo> {
    let url_ = this.baseUrl + '/api/UserAdmin/{userId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUser(_response);
    });
  }

  protected processGetUser(response: Response): Promise<UserInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserInfo.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserInfo>(null as any);
  }

  dELETEUserEveryWhere(userId: string | null): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAdmin/{userId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDELETEUserEveryWhere(_response);
    });
  }

  protected processDELETEUserEveryWhere(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  addUserToCustomer(userId: string | null, customerId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAdmin/{userId}/customers/{customerId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddUserToCustomer(_response);
    });
  }

  protected processAddUserToCustomer(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeUserCustomer(userId: string | null, customerId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAdmin/{userId}/customers/{customerId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveUserCustomer(_response);
    });
  }

  protected processRemoveUserCustomer(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  addUserRole(userId: string | null, role: Role): Promise<Role[]> {
    let url_ = this.baseUrl + '/api/UserAdmin/{userId}/roles';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(role);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddUserRole(_response);
    });
  }

  protected processAddUserRole(response: Response): Promise<Role[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Role[]>(null as any);
  }

  removeUserRole(userId: string | null, role: Role): Promise<Role[]> {
    let url_ = this.baseUrl + '/api/UserAdmin/{userId}/roles';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(role);

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveUserRole(_response);
    });
  }

  protected processRemoveUserRole(response: Response): Promise<Role[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Role[]>(null as any);
  }
}

export class UserClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getUserInfo(): Promise<UserInfo> {
    let url_ = this.baseUrl + '/api/User/me';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserInfo(_response);
    });
  }

  protected processGetUserInfo(response: Response): Promise<UserInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserInfo.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserInfo>(null as any);
  }

  changeCustomer(customerId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/User/me/customer';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(customerId);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangeCustomer(_response);
    });
  }

  protected processChangeCustomer(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  inviteUser(inviteeEmail: string): Promise<void> {
    let url_ = this.baseUrl + '/api/User/invitations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(inviteeEmail);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processInviteUser(_response);
    });
  }

  protected processInviteUser(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getInvitations(): Promise<UserInvitationModel[]> {
    let url_ = this.baseUrl + '/api/User/invitations';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetInvitations(_response);
    });
  }

  protected processGetInvitations(
    response: Response
  ): Promise<UserInvitationModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(UserInvitationModel.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserInvitationModel[]>(null as any);
  }

  deleteInvitation(id: string): Promise<void> {
    let url_ = this.baseUrl + '/api/User/invitations/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteInvitation(_response);
    });
  }

  protected processDeleteInvitation(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeUser(userId: string | null): Promise<void> {
    let url_ = this.baseUrl + '/api/User/users/{userId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveUser(_response);
    });
  }

  protected processRemoveUser(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getUsers(): Promise<UserInfo[]> {
    let url_ = this.baseUrl + '/api/User/users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUsers(_response);
    });
  }

  protected processGetUsers(response: Response): Promise<UserInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ''
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(UserInfo.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserInfo[]>(null as any);
  }
}

export class AppTexts implements IAppTexts {
  appName!: string;
  inventoryStatuses!: { [key in keyof typeof InventoryStatus]?: string };
  departmentTypes!: { [key in keyof typeof DepartmentType]?: string };
  inventorySources!: { [key in keyof typeof InventorySource]?: string };
  inventoryPickupTypes!: {
    [key in keyof typeof InventoryDeliveryType]?: string;
  };
  propertyChangeMap!: { [key: string]: string };

  constructor(data?: IAppTexts) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.inventoryStatuses = {};
      this.departmentTypes = {};
      this.inventorySources = {};
      this.inventoryPickupTypes = {};
      this.propertyChangeMap = {};
    }
  }

  init(_data?: any) {
    if (_data) {
      this.appName = _data['appName'];
      if (_data['inventoryStatuses']) {
        this.inventoryStatuses = {} as any;
        for (let key in _data['inventoryStatuses']) {
          if (_data['inventoryStatuses'].hasOwnProperty(key))
            (<any>this.inventoryStatuses)![key] =
              _data['inventoryStatuses'][key];
        }
      }
      if (_data['departmentTypes']) {
        this.departmentTypes = {} as any;
        for (let key in _data['departmentTypes']) {
          if (_data['departmentTypes'].hasOwnProperty(key))
            (<any>this.departmentTypes)![key] = _data['departmentTypes'][key];
        }
      }
      if (_data['inventorySources']) {
        this.inventorySources = {} as any;
        for (let key in _data['inventorySources']) {
          if (_data['inventorySources'].hasOwnProperty(key))
            (<any>this.inventorySources)![key] = _data['inventorySources'][key];
        }
      }
      if (_data['inventoryPickupTypes']) {
        this.inventoryPickupTypes = {} as any;
        for (let key in _data['inventoryPickupTypes']) {
          if (_data['inventoryPickupTypes'].hasOwnProperty(key))
            (<any>this.inventoryPickupTypes)![key] =
              _data['inventoryPickupTypes'][key];
        }
      }
      if (_data['propertyChangeMap']) {
        this.propertyChangeMap = {} as any;
        for (let key in _data['propertyChangeMap']) {
          if (_data['propertyChangeMap'].hasOwnProperty(key))
            (<any>this.propertyChangeMap)![key] =
              _data['propertyChangeMap'][key];
        }
      }
    }
  }

  static fromJS(data: any): AppTexts {
    data = typeof data === 'object' ? data : {};
    let result = new AppTexts();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['appName'] = this.appName;
    if (this.inventoryStatuses) {
      data['inventoryStatuses'] = {};
      for (let key in this.inventoryStatuses) {
        if (this.inventoryStatuses.hasOwnProperty(key))
          (<any>data['inventoryStatuses'])[key] = (<any>this.inventoryStatuses)[
            key
          ];
      }
    }
    if (this.departmentTypes) {
      data['departmentTypes'] = {};
      for (let key in this.departmentTypes) {
        if (this.departmentTypes.hasOwnProperty(key))
          (<any>data['departmentTypes'])[key] = (<any>this.departmentTypes)[
            key
          ];
      }
    }
    if (this.inventorySources) {
      data['inventorySources'] = {};
      for (let key in this.inventorySources) {
        if (this.inventorySources.hasOwnProperty(key))
          (<any>data['inventorySources'])[key] = (<any>this.inventorySources)[
            key
          ];
      }
    }
    if (this.inventoryPickupTypes) {
      data['inventoryPickupTypes'] = {};
      for (let key in this.inventoryPickupTypes) {
        if (this.inventoryPickupTypes.hasOwnProperty(key))
          (<any>data['inventoryPickupTypes'])[key] = (<any>(
            this.inventoryPickupTypes
          ))[key];
      }
    }
    if (this.propertyChangeMap) {
      data['propertyChangeMap'] = {};
      for (let key in this.propertyChangeMap) {
        if (this.propertyChangeMap.hasOwnProperty(key))
          (<any>data['propertyChangeMap'])[key] = (<any>this.propertyChangeMap)[
            key
          ];
      }
    }
    return data;
  }
}

export interface IAppTexts {
  appName: string;
  inventoryStatuses: { [key in keyof typeof InventoryStatus]?: string };
  departmentTypes: { [key in keyof typeof DepartmentType]?: string };
  inventorySources: { [key in keyof typeof InventorySource]?: string };
  inventoryPickupTypes: {
    [key in keyof typeof InventoryDeliveryType]?: string;
  };
  propertyChangeMap: { [key: string]: string };
}

export enum InventoryStatus {
  Unknown = 0,
  New = 1,
  DigitalInOrdered = 2,
  AssistOrdered = 3,
  InTransitToStagingLot = 4,
  InTransitToRepairShop = 5,
  StandBy = 6,
  Closed = 7,
  Removed = 8,
}

export enum DepartmentType {
  Engine = 1,
  Plate = 3,
  Glass = 4,
  SalvageYard = 5,
  Dump = 6,
  HeavyVehicles = 7,
  Tire = 8,
  Other = 9,
  MotorCycle = 10,
  TireOnCall = 11,
  TransportAgencyTrv = 12,
}

export enum InventorySource {
  Ak = 0,
  Manual = 1,
}

export enum InventoryDeliveryType {
  Ak = 0,
  Own = 1,
}

export class Case implements ICase {
  id!: number;
  repairShopId!: number;
  wreck?: Vehicle | undefined;
  incident?: Incident | undefined;
  tower?: Contact | undefined;
  customer?: Contact | undefined;
  eta?: Date | undefined;
  assignmentStatusID!: number;
  latestReportLocationTypeID?: number | undefined;
  leftIncidentTimeStamp?: Date | undefined;
  leftVehicleTimeStamp?: Date | undefined;

  constructor(data?: ICase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.repairShopId = _data['repairShopId'];
      this.wreck = _data['wreck']
        ? Vehicle.fromJS(_data['wreck'])
        : <any>undefined;
      this.incident = _data['incident']
        ? Incident.fromJS(_data['incident'])
        : <any>undefined;
      this.tower = _data['tower']
        ? Contact.fromJS(_data['tower'])
        : <any>undefined;
      this.customer = _data['customer']
        ? Contact.fromJS(_data['customer'])
        : <any>undefined;
      this.eta = _data['eta']
        ? new Date(_data['eta'].toString())
        : <any>undefined;
      this.assignmentStatusID = _data['assignmentStatusID'];
      this.latestReportLocationTypeID = _data['latestReportLocationTypeID'];
      this.leftIncidentTimeStamp = _data['leftIncidentTimeStamp']
        ? new Date(_data['leftIncidentTimeStamp'].toString())
        : <any>undefined;
      this.leftVehicleTimeStamp = _data['leftVehicleTimeStamp']
        ? new Date(_data['leftVehicleTimeStamp'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): Case {
    data = typeof data === 'object' ? data : {};
    let result = new Case();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['repairShopId'] = this.repairShopId;
    data['wreck'] = this.wreck ? this.wreck.toJSON() : <any>undefined;
    data['incident'] = this.incident ? this.incident.toJSON() : <any>undefined;
    data['tower'] = this.tower ? this.tower.toJSON() : <any>undefined;
    data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
    data['eta'] = this.eta ? this.eta.toISOString() : <any>undefined;
    data['assignmentStatusID'] = this.assignmentStatusID;
    data['latestReportLocationTypeID'] = this.latestReportLocationTypeID;
    data['leftIncidentTimeStamp'] = this.leftIncidentTimeStamp
      ? this.leftIncidentTimeStamp.toISOString()
      : <any>undefined;
    data['leftVehicleTimeStamp'] = this.leftVehicleTimeStamp
      ? this.leftVehicleTimeStamp.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface ICase {
  id: number;
  repairShopId: number;
  wreck?: Vehicle | undefined;
  incident?: Incident | undefined;
  tower?: Contact | undefined;
  customer?: Contact | undefined;
  eta?: Date | undefined;
  assignmentStatusID: number;
  latestReportLocationTypeID?: number | undefined;
  leftIncidentTimeStamp?: Date | undefined;
  leftVehicleTimeStamp?: Date | undefined;
}

export class Vehicle implements IVehicle {
  registrationNumber?: string | undefined;
  make?: string | undefined;
  model?: string | undefined;
  insuranceInformation?: string | undefined;

  constructor(data?: IVehicle) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.registrationNumber = _data['registrationNumber'];
      this.make = _data['make'];
      this.model = _data['model'];
      this.insuranceInformation = _data['insuranceInformation'];
    }
  }

  static fromJS(data: any): Vehicle {
    data = typeof data === 'object' ? data : {};
    let result = new Vehicle();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['registrationNumber'] = this.registrationNumber;
    data['make'] = this.make;
    data['model'] = this.model;
    data['insuranceInformation'] = this.insuranceInformation;
    return data;
  }
}

export interface IVehicle {
  registrationNumber?: string | undefined;
  make?: string | undefined;
  model?: string | undefined;
  insuranceInformation?: string | undefined;
}

export class Incident implements IIncident {
  type?: string | undefined;
  description?: string | undefined;
  date!: Date;
  images?: string[] | undefined;
  thumbnailImages?: string[] | undefined;
  typeID?: number | undefined;

  constructor(data?: IIncident) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.description = _data['description'];
      this.date = _data['date']
        ? new Date(_data['date'].toString())
        : <any>undefined;
      if (Array.isArray(_data['images'])) {
        this.images = [] as any;
        for (let item of _data['images']) this.images!.push(item);
      }
      if (Array.isArray(_data['thumbnailImages'])) {
        this.thumbnailImages = [] as any;
        for (let item of _data['thumbnailImages'])
          this.thumbnailImages!.push(item);
      }
      this.typeID = _data['typeID'];
    }
  }

  static fromJS(data: any): Incident {
    data = typeof data === 'object' ? data : {};
    let result = new Incident();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['description'] = this.description;
    data['date'] = this.date ? this.date.toISOString() : <any>undefined;
    if (Array.isArray(this.images)) {
      data['images'] = [];
      for (let item of this.images) data['images'].push(item);
    }
    if (Array.isArray(this.thumbnailImages)) {
      data['thumbnailImages'] = [];
      for (let item of this.thumbnailImages) data['thumbnailImages'].push(item);
    }
    data['typeID'] = this.typeID;
    return data;
  }
}

export interface IIncident {
  type?: string | undefined;
  description?: string | undefined;
  date: Date;
  images?: string[] | undefined;
  thumbnailImages?: string[] | undefined;
  typeID?: number | undefined;
}

export class Contact implements IContact {
  name?: string | undefined;
  phoneNumber?: string | undefined;

  constructor(data?: IContact) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.phoneNumber = _data['phoneNumber'];
    }
  }

  static fromJS(data: any): Contact {
    data = typeof data === 'object' ? data : {};
    let result = new Contact();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['phoneNumber'] = this.phoneNumber;
    return data;
  }
}

export interface IContact {
  name?: string | undefined;
  phoneNumber?: string | undefined;
}

export class CustomerPreviewModel implements ICustomerPreviewModel {
  id!: number;
  isActive!: boolean;
  repairshopId!: number;
  displayName?: string | undefined;
  orgNr?: string | undefined;
  statisticsDistanceInKm!: number;
  stagingGroupId?: number | undefined;

  constructor(data?: ICustomerPreviewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.isActive = _data['isActive'];
      this.repairshopId = _data['repairshopId'];
      this.displayName = _data['displayName'];
      this.orgNr = _data['orgNr'];
      this.statisticsDistanceInKm = _data['statisticsDistanceInKm'];
      this.stagingGroupId = _data['stagingGroupId'];
    }
  }

  static fromJS(data: any): CustomerPreviewModel {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerPreviewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['isActive'] = this.isActive;
    data['repairshopId'] = this.repairshopId;
    data['displayName'] = this.displayName;
    data['orgNr'] = this.orgNr;
    data['statisticsDistanceInKm'] = this.statisticsDistanceInKm;
    data['stagingGroupId'] = this.stagingGroupId;
    return data;
  }
}

export interface ICustomerPreviewModel {
  id: number;
  isActive: boolean;
  repairshopId: number;
  displayName?: string | undefined;
  orgNr?: string | undefined;
  statisticsDistanceInKm: number;
  stagingGroupId?: number | undefined;
}

export class CustomerModel
  extends CustomerPreviewModel
  implements ICustomerModel
{
  stations?: StationModel[] | undefined;

  constructor(data?: ICustomerModel) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data['stations'])) {
        this.stations = [] as any;
        for (let item of _data['stations'])
          this.stations!.push(StationModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerModel {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.stations)) {
      data['stations'] = [];
      for (let item of this.stations) data['stations'].push(item.toJSON());
    }
    super.toJSON(data);
    return data;
  }
}

export interface ICustomerModel extends ICustomerPreviewModel {
  stations?: StationModel[] | undefined;
}

export class StationPreviewModel implements IStationPreviewModel {
  id!: number;
  name?: string | undefined;
  postAddress?: string | undefined;
  zipCode?: string | undefined;

  constructor(data?: IStationPreviewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.postAddress = _data['postAddress'];
      this.zipCode = _data['zipCode'];
    }
  }

  static fromJS(data: any): StationPreviewModel {
    data = typeof data === 'object' ? data : {};
    let result = new StationPreviewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['postAddress'] = this.postAddress;
    data['zipCode'] = this.zipCode;
    return data;
  }
}

export interface IStationPreviewModel {
  id: number;
  name?: string | undefined;
  postAddress?: string | undefined;
  zipCode?: string | undefined;
}

export class StationModel extends StationPreviewModel implements IStationModel {
  towers?: TowerModel[] | undefined;

  constructor(data?: IStationModel) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data['towers'])) {
        this.towers = [] as any;
        for (let item of _data['towers'])
          this.towers!.push(TowerModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StationModel {
    data = typeof data === 'object' ? data : {};
    let result = new StationModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.towers)) {
      data['towers'] = [];
      for (let item of this.towers) data['towers'].push(item.toJSON());
    }
    super.toJSON(data);
    return data;
  }
}

export interface IStationModel extends IStationPreviewModel {
  towers?: TowerModel[] | undefined;
}

export class TowerModel implements ITowerModel {
  id!: number;
  stationId!: number;
  name?: string | undefined;
  phoneNumber?: string | undefined;
  mailAddress?: string | undefined;
  profileImageLink?: string | undefined;
  towerRole?: string | undefined;

  constructor(data?: ITowerModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.stationId = _data['stationId'];
      this.name = _data['name'];
      this.phoneNumber = _data['phoneNumber'];
      this.mailAddress = _data['mailAddress'];
      this.profileImageLink = _data['profileImageLink'];
      this.towerRole = _data['towerRole'];
    }
  }

  static fromJS(data: any): TowerModel {
    data = typeof data === 'object' ? data : {};
    let result = new TowerModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['stationId'] = this.stationId;
    data['name'] = this.name;
    data['phoneNumber'] = this.phoneNumber;
    data['mailAddress'] = this.mailAddress;
    data['profileImageLink'] = this.profileImageLink;
    data['towerRole'] = this.towerRole;
    return data;
  }
}

export interface ITowerModel {
  id: number;
  stationId: number;
  name?: string | undefined;
  phoneNumber?: string | undefined;
  mailAddress?: string | undefined;
  profileImageLink?: string | undefined;
  towerRole?: string | undefined;
}

export class InventoryModel implements IInventoryModel {
  id!: number;
  departmentType?: DepartmentType | undefined;
  status!: InventoryStatus;
  registrationNumber?: string | undefined;
  stagingLotName?: string | undefined;
  source!: InventorySource;
  images?: InventoryImage[] | undefined;
  numberOfComments!: number;
  repairShopId!: number;
  stagingLotId!: number;
  inspection?: Date | undefined;
  serviceCaseDetails?: ServiceCaseDetailsModel[] | undefined;
  transferToStagingLot?: TransferModel | undefined;
  transferToRepairShop?: TransferModel | undefined;

  constructor(data?: IInventoryModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.departmentType = _data['departmentType'];
      this.status = _data['status'];
      this.registrationNumber = _data['registrationNumber'];
      this.stagingLotName = _data['stagingLotName'];
      this.source = _data['source'];
      if (Array.isArray(_data['images'])) {
        this.images = [] as any;
        for (let item of _data['images'])
          this.images!.push(InventoryImage.fromJS(item));
      }
      this.numberOfComments = _data['numberOfComments'];
      this.repairShopId = _data['repairShopId'];
      this.stagingLotId = _data['stagingLotId'];
      this.inspection = _data['inspection']
        ? new Date(_data['inspection'].toString())
        : <any>undefined;
      if (Array.isArray(_data['serviceCaseDetails'])) {
        this.serviceCaseDetails = [] as any;
        for (let item of _data['serviceCaseDetails'])
          this.serviceCaseDetails!.push(ServiceCaseDetailsModel.fromJS(item));
      }
      this.transferToStagingLot = _data['transferToStagingLot']
        ? TransferModel.fromJS(_data['transferToStagingLot'])
        : <any>undefined;
      this.transferToRepairShop = _data['transferToRepairShop']
        ? TransferModel.fromJS(_data['transferToRepairShop'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): InventoryModel {
    data = typeof data === 'object' ? data : {};
    let result = new InventoryModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['departmentType'] = this.departmentType;
    data['status'] = this.status;
    data['registrationNumber'] = this.registrationNumber;
    data['stagingLotName'] = this.stagingLotName;
    data['source'] = this.source;
    if (Array.isArray(this.images)) {
      data['images'] = [];
      for (let item of this.images) data['images'].push(item.toJSON());
    }
    data['numberOfComments'] = this.numberOfComments;
    data['repairShopId'] = this.repairShopId;
    data['stagingLotId'] = this.stagingLotId;
    data['inspection'] = this.inspection
      ? this.inspection.toISOString()
      : <any>undefined;
    if (Array.isArray(this.serviceCaseDetails)) {
      data['serviceCaseDetails'] = [];
      for (let item of this.serviceCaseDetails)
        data['serviceCaseDetails'].push(item.toJSON());
    }
    data['transferToStagingLot'] = this.transferToStagingLot
      ? this.transferToStagingLot.toJSON()
      : <any>undefined;
    data['transferToRepairShop'] = this.transferToRepairShop
      ? this.transferToRepairShop.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IInventoryModel {
  id: number;
  departmentType?: DepartmentType | undefined;
  status: InventoryStatus;
  registrationNumber?: string | undefined;
  stagingLotName?: string | undefined;
  source: InventorySource;
  images?: InventoryImage[] | undefined;
  numberOfComments: number;
  repairShopId: number;
  stagingLotId: number;
  inspection?: Date | undefined;
  serviceCaseDetails?: ServiceCaseDetailsModel[] | undefined;
  transferToStagingLot?: TransferModel | undefined;
  transferToRepairShop?: TransferModel | undefined;
}

export class InventoryImage implements IInventoryImage {
  imageUrl?: string | undefined;
  thumbnailUrl?: string | undefined;
  serviceCaseId!: number;

  constructor(data?: IInventoryImage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.imageUrl = _data['imageUrl'];
      this.thumbnailUrl = _data['thumbnailUrl'];
      this.serviceCaseId = _data['serviceCaseId'];
    }
  }

  static fromJS(data: any): InventoryImage {
    data = typeof data === 'object' ? data : {};
    let result = new InventoryImage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['imageUrl'] = this.imageUrl;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['serviceCaseId'] = this.serviceCaseId;
    return data;
  }
}

export interface IInventoryImage {
  imageUrl?: string | undefined;
  thumbnailUrl?: string | undefined;
  serviceCaseId: number;
}

export class ServiceCaseDetailsModel implements IServiceCaseDetailsModel {
  customerName?: string | undefined;
  customerPhoneNumber?: string | undefined;
  incidentType?: string | undefined;
  incidentTypeId?: number | undefined;
  incidentDescription?: string | undefined;
  incidentDate!: Date;

  constructor(data?: IServiceCaseDetailsModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerName = _data['customerName'];
      this.customerPhoneNumber = _data['customerPhoneNumber'];
      this.incidentType = _data['incidentType'];
      this.incidentTypeId = _data['incidentTypeId'];
      this.incidentDescription = _data['incidentDescription'];
      this.incidentDate = _data['incidentDate']
        ? new Date(_data['incidentDate'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ServiceCaseDetailsModel {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceCaseDetailsModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['customerName'] = this.customerName;
    data['customerPhoneNumber'] = this.customerPhoneNumber;
    data['incidentType'] = this.incidentType;
    data['incidentTypeId'] = this.incidentTypeId;
    data['incidentDescription'] = this.incidentDescription;
    data['incidentDate'] = this.incidentDate
      ? this.incidentDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IServiceCaseDetailsModel {
  customerName?: string | undefined;
  customerPhoneNumber?: string | undefined;
  incidentType?: string | undefined;
  incidentTypeId?: number | undefined;
  incidentDescription?: string | undefined;
  incidentDate: Date;
}

export class TransferModel implements ITransferModel {
  transferId!: number;
  plannedDelivery?: Date | undefined;
  actualPickup?: Date | undefined;
  actualDelivery?: Date | undefined;
  pickUpType?: InventoryDeliveryType | undefined;
  isRebookable!: boolean;

  constructor(data?: ITransferModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transferId = _data['transferId'];
      this.plannedDelivery = _data['plannedDelivery']
        ? new Date(_data['plannedDelivery'].toString())
        : <any>undefined;
      this.actualPickup = _data['actualPickup']
        ? new Date(_data['actualPickup'].toString())
        : <any>undefined;
      this.actualDelivery = _data['actualDelivery']
        ? new Date(_data['actualDelivery'].toString())
        : <any>undefined;
      this.pickUpType = _data['pickUpType'];
      this.isRebookable = _data['isRebookable'];
    }
  }

  static fromJS(data: any): TransferModel {
    data = typeof data === 'object' ? data : {};
    let result = new TransferModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['transferId'] = this.transferId;
    data['plannedDelivery'] = this.plannedDelivery
      ? this.plannedDelivery.toISOString()
      : <any>undefined;
    data['actualPickup'] = this.actualPickup
      ? this.actualPickup.toISOString()
      : <any>undefined;
    data['actualDelivery'] = this.actualDelivery
      ? this.actualDelivery.toISOString()
      : <any>undefined;
    data['pickUpType'] = this.pickUpType;
    data['isRebookable'] = this.isRebookable;
    return data;
  }
}

export interface ITransferModel {
  transferId: number;
  plannedDelivery?: Date | undefined;
  actualPickup?: Date | undefined;
  actualDelivery?: Date | undefined;
  pickUpType?: InventoryDeliveryType | undefined;
  isRebookable: boolean;
}

export class InventorySearchRequest implements IInventorySearchRequest {
  registrationNumber?: string | undefined;
  includeClosed!: boolean;

  constructor(data?: IInventorySearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.registrationNumber = _data['registrationNumber'];
      this.includeClosed = _data['includeClosed'];
    }
  }

  static fromJS(data: any): InventorySearchRequest {
    data = typeof data === 'object' ? data : {};
    let result = new InventorySearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['registrationNumber'] = this.registrationNumber;
    data['includeClosed'] = this.includeClosed;
    return data;
  }
}

export interface IInventorySearchRequest {
  registrationNumber?: string | undefined;
  includeClosed: boolean;
}

export class InventoryCommentModel implements IInventoryCommentModel {
  id!: number;
  text?: string | undefined;
  inventoryId!: number;
  created!: Date;
  userName?: string | undefined;
  userId?: string | undefined;

  constructor(data?: IInventoryCommentModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.text = _data['text'];
      this.inventoryId = _data['inventoryId'];
      this.created = _data['created']
        ? new Date(_data['created'].toString())
        : <any>undefined;
      this.userName = _data['userName'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): InventoryCommentModel {
    data = typeof data === 'object' ? data : {};
    let result = new InventoryCommentModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['text'] = this.text;
    data['inventoryId'] = this.inventoryId;
    data['created'] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data['userName'] = this.userName;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IInventoryCommentModel {
  id: number;
  text?: string | undefined;
  inventoryId: number;
  created: Date;
  userName?: string | undefined;
  userId?: string | undefined;
}

export class UpdateInventoryRequest implements IUpdateInventoryRequest {
  registrationNumber?: string | undefined;
  departmentType?: DepartmentType | undefined;
  status!: InventoryStatus;
  plannedDeliveryToStagingLot?: Date | undefined;
  actualPickupToStagingLot?: Date | undefined;
  actualDeliveryToStagingLot?: Date | undefined;
  plannedDeliveryToRepairShop?: Date | undefined;
  actualPickupToRepairShop?: Date | undefined;
  actualDeliveryToRepairShop?: Date | undefined;
  inspection?: Date | undefined;

  constructor(data?: IUpdateInventoryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.registrationNumber = _data['registrationNumber'];
      this.departmentType = _data['departmentType'];
      this.status = _data['status'];
      this.plannedDeliveryToStagingLot = _data['plannedDeliveryToStagingLot']
        ? new Date(_data['plannedDeliveryToStagingLot'].toString())
        : <any>undefined;
      this.actualPickupToStagingLot = _data['actualPickupToStagingLot']
        ? new Date(_data['actualPickupToStagingLot'].toString())
        : <any>undefined;
      this.actualDeliveryToStagingLot = _data['actualDeliveryToStagingLot']
        ? new Date(_data['actualDeliveryToStagingLot'].toString())
        : <any>undefined;
      this.plannedDeliveryToRepairShop = _data['plannedDeliveryToRepairShop']
        ? new Date(_data['plannedDeliveryToRepairShop'].toString())
        : <any>undefined;
      this.actualPickupToRepairShop = _data['actualPickupToRepairShop']
        ? new Date(_data['actualPickupToRepairShop'].toString())
        : <any>undefined;
      this.actualDeliveryToRepairShop = _data['actualDeliveryToRepairShop']
        ? new Date(_data['actualDeliveryToRepairShop'].toString())
        : <any>undefined;
      this.inspection = _data['inspection']
        ? new Date(_data['inspection'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateInventoryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateInventoryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['registrationNumber'] = this.registrationNumber;
    data['departmentType'] = this.departmentType;
    data['status'] = this.status;
    data['plannedDeliveryToStagingLot'] = this.plannedDeliveryToStagingLot
      ? this.plannedDeliveryToStagingLot.toISOString()
      : <any>undefined;
    data['actualPickupToStagingLot'] = this.actualPickupToStagingLot
      ? this.actualPickupToStagingLot.toISOString()
      : <any>undefined;
    data['actualDeliveryToStagingLot'] = this.actualDeliveryToStagingLot
      ? this.actualDeliveryToStagingLot.toISOString()
      : <any>undefined;
    data['plannedDeliveryToRepairShop'] = this.plannedDeliveryToRepairShop
      ? this.plannedDeliveryToRepairShop.toISOString()
      : <any>undefined;
    data['actualPickupToRepairShop'] = this.actualPickupToRepairShop
      ? this.actualPickupToRepairShop.toISOString()
      : <any>undefined;
    data['actualDeliveryToRepairShop'] = this.actualDeliveryToRepairShop
      ? this.actualDeliveryToRepairShop.toISOString()
      : <any>undefined;
    data['inspection'] = this.inspection
      ? this.inspection.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IUpdateInventoryRequest {
  registrationNumber?: string | undefined;
  departmentType?: DepartmentType | undefined;
  status: InventoryStatus;
  plannedDeliveryToStagingLot?: Date | undefined;
  actualPickupToStagingLot?: Date | undefined;
  actualDeliveryToStagingLot?: Date | undefined;
  plannedDeliveryToRepairShop?: Date | undefined;
  actualPickupToRepairShop?: Date | undefined;
  actualDeliveryToRepairShop?: Date | undefined;
  inspection?: Date | undefined;
}

export class CreateInventoryRequest implements ICreateInventoryRequest {
  registrationNumber?: string | undefined;
  departmentTypeId?: DepartmentType | undefined;
  status!: InventoryStatus;
  plannedDeliveryToStagingLot?: Date | undefined;
  actualDeliveryToStagingLot?: Date | undefined;
  repairShopId!: number;
  comment?: string | undefined;

  constructor(data?: ICreateInventoryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.registrationNumber = _data['registrationNumber'];
      this.departmentTypeId = _data['departmentTypeId'];
      this.status = _data['status'];
      this.plannedDeliveryToStagingLot = _data['plannedDeliveryToStagingLot']
        ? new Date(_data['plannedDeliveryToStagingLot'].toString())
        : <any>undefined;
      this.actualDeliveryToStagingLot = _data['actualDeliveryToStagingLot']
        ? new Date(_data['actualDeliveryToStagingLot'].toString())
        : <any>undefined;
      this.repairShopId = _data['repairShopId'];
      this.comment = _data['comment'];
    }
  }

  static fromJS(data: any): CreateInventoryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateInventoryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['registrationNumber'] = this.registrationNumber;
    data['departmentTypeId'] = this.departmentTypeId;
    data['status'] = this.status;
    data['plannedDeliveryToStagingLot'] = this.plannedDeliveryToStagingLot
      ? this.plannedDeliveryToStagingLot.toISOString()
      : <any>undefined;
    data['actualDeliveryToStagingLot'] = this.actualDeliveryToStagingLot
      ? this.actualDeliveryToStagingLot.toISOString()
      : <any>undefined;
    data['repairShopId'] = this.repairShopId;
    data['comment'] = this.comment;
    return data;
  }
}

export interface ICreateInventoryRequest {
  registrationNumber?: string | undefined;
  departmentTypeId?: DepartmentType | undefined;
  status: InventoryStatus;
  plannedDeliveryToStagingLot?: Date | undefined;
  actualDeliveryToStagingLot?: Date | undefined;
  repairShopId: number;
  comment?: string | undefined;
}

export class CreateInventoryTransferRequest
  implements ICreateInventoryTransferRequest
{
  plannedDeliveryToRepairShop!: Date;
  fromRepairShopId!: number;
  toRepairShopId!: number;
  toStagingLot!: boolean;

  constructor(data?: ICreateInventoryTransferRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.plannedDeliveryToRepairShop = _data['plannedDeliveryToRepairShop']
        ? new Date(_data['plannedDeliveryToRepairShop'].toString())
        : <any>undefined;
      this.fromRepairShopId = _data['fromRepairShopId'];
      this.toRepairShopId = _data['toRepairShopId'];
      this.toStagingLot = _data['toStagingLot'];
    }
  }

  static fromJS(data: any): CreateInventoryTransferRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateInventoryTransferRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['plannedDeliveryToRepairShop'] = this.plannedDeliveryToRepairShop
      ? this.plannedDeliveryToRepairShop.toISOString()
      : <any>undefined;
    data['fromRepairShopId'] = this.fromRepairShopId;
    data['toRepairShopId'] = this.toRepairShopId;
    data['toStagingLot'] = this.toStagingLot;
    return data;
  }
}

export interface ICreateInventoryTransferRequest {
  plannedDeliveryToRepairShop: Date;
  fromRepairShopId: number;
  toRepairShopId: number;
  toStagingLot: boolean;
}

export class AssignmentModel implements IAssignmentModel {
  imageThumbnailLinks?: string[] | undefined;
  imageLinks?: string[] | undefined;
  registrationNumber?: string | undefined;
  vehicleType?: string | undefined;
  vehicleBrand?: string | undefined;
  incidentType?: string | undefined;
  incidentNotes?: string | undefined;
  leftIncidentDateString?: string | undefined;
  towerName?: string | undefined;
  towerPhoneNumber?: string | undefined;
  eta?: string | undefined;

  constructor(data?: IAssignmentModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['imageThumbnailLinks'])) {
        this.imageThumbnailLinks = [] as any;
        for (let item of _data['imageThumbnailLinks'])
          this.imageThumbnailLinks!.push(item);
      }
      if (Array.isArray(_data['imageLinks'])) {
        this.imageLinks = [] as any;
        for (let item of _data['imageLinks']) this.imageLinks!.push(item);
      }
      this.registrationNumber = _data['registrationNumber'];
      this.vehicleType = _data['vehicleType'];
      this.vehicleBrand = _data['vehicleBrand'];
      this.incidentType = _data['incidentType'];
      this.incidentNotes = _data['incidentNotes'];
      this.leftIncidentDateString = _data['leftIncidentDateString'];
      this.towerName = _data['towerName'];
      this.towerPhoneNumber = _data['towerPhoneNumber'];
      this.eta = _data['eta'];
    }
  }

  static fromJS(data: any): AssignmentModel {
    data = typeof data === 'object' ? data : {};
    let result = new AssignmentModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.imageThumbnailLinks)) {
      data['imageThumbnailLinks'] = [];
      for (let item of this.imageThumbnailLinks)
        data['imageThumbnailLinks'].push(item);
    }
    if (Array.isArray(this.imageLinks)) {
      data['imageLinks'] = [];
      for (let item of this.imageLinks) data['imageLinks'].push(item);
    }
    data['registrationNumber'] = this.registrationNumber;
    data['vehicleType'] = this.vehicleType;
    data['vehicleBrand'] = this.vehicleBrand;
    data['incidentType'] = this.incidentType;
    data['incidentNotes'] = this.incidentNotes;
    data['leftIncidentDateString'] = this.leftIncidentDateString;
    data['towerName'] = this.towerName;
    data['towerPhoneNumber'] = this.towerPhoneNumber;
    data['eta'] = this.eta;
    return data;
  }
}

export interface IAssignmentModel {
  imageThumbnailLinks?: string[] | undefined;
  imageLinks?: string[] | undefined;
  registrationNumber?: string | undefined;
  vehicleType?: string | undefined;
  vehicleBrand?: string | undefined;
  incidentType?: string | undefined;
  incidentNotes?: string | undefined;
  leftIncidentDateString?: string | undefined;
  towerName?: string | undefined;
  towerPhoneNumber?: string | undefined;
  eta?: string | undefined;
}

export class NotificationReceiverDto implements INotificationReceiverDto {
  id!: number;
  type?: string | undefined;
  value?: string | undefined;
  description?: string | undefined;
  active!: boolean;
  activeFromMsOnUTCDay!: number;
  activeToMsOnUTCDay!: number;
  created!: Date;
  updated!: Date;
  customerID!: number;

  constructor(data?: INotificationReceiverDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.value = _data['value'];
      this.description = _data['description'];
      this.active = _data['active'];
      this.activeFromMsOnUTCDay = _data['activeFromMsOnUTCDay'];
      this.activeToMsOnUTCDay = _data['activeToMsOnUTCDay'];
      this.created = _data['created']
        ? new Date(_data['created'].toString())
        : <any>undefined;
      this.updated = _data['updated']
        ? new Date(_data['updated'].toString())
        : <any>undefined;
      this.customerID = _data['customerID'];
    }
  }

  static fromJS(data: any): NotificationReceiverDto {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationReceiverDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['value'] = this.value;
    data['description'] = this.description;
    data['active'] = this.active;
    data['activeFromMsOnUTCDay'] = this.activeFromMsOnUTCDay;
    data['activeToMsOnUTCDay'] = this.activeToMsOnUTCDay;
    data['created'] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data['updated'] = this.updated
      ? this.updated.toISOString()
      : <any>undefined;
    data['customerID'] = this.customerID;
    return data;
  }
}

export interface INotificationReceiverDto {
  id: number;
  type?: string | undefined;
  value?: string | undefined;
  description?: string | undefined;
  active: boolean;
  activeFromMsOnUTCDay: number;
  activeToMsOnUTCDay: number;
  created: Date;
  updated: Date;
  customerID: number;
}

export class WebOrder implements IWebOrder {
  created!: Date;
  longitude!: number;
  latitude!: number;
  pickupLocation?: string | undefined;
  registrationNumber?: string | undefined;
  name?: string | undefined;
  phoneNumber?: string | undefined;
  requestedDropOffLocation?: string | undefined;
  comment?: string | undefined;
  status?: string | undefined;
  feedbackEmails?: string[] | undefined;
  feedbackSMS?: string[] | undefined;
  orderDate?: Date | undefined;
  inventoryId?: number | undefined;
  fromRepairShopId?: number | undefined;
  toRepairShopId?: number | undefined;

  constructor(data?: IWebOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.created = _data['created']
        ? new Date(_data['created'].toString())
        : <any>undefined;
      this.longitude = _data['longitude'];
      this.latitude = _data['latitude'];
      this.pickupLocation = _data['pickupLocation'];
      this.registrationNumber = _data['registrationNumber'];
      this.name = _data['name'];
      this.phoneNumber = _data['phoneNumber'];
      this.requestedDropOffLocation = _data['requestedDropOffLocation'];
      this.comment = _data['comment'];
      this.status = _data['status'];
      if (Array.isArray(_data['feedbackEmails'])) {
        this.feedbackEmails = [] as any;
        for (let item of _data['feedbackEmails'])
          this.feedbackEmails!.push(item);
      }
      if (Array.isArray(_data['feedbackSMS'])) {
        this.feedbackSMS = [] as any;
        for (let item of _data['feedbackSMS']) this.feedbackSMS!.push(item);
      }
      this.orderDate = _data['orderDate']
        ? new Date(_data['orderDate'].toString())
        : <any>undefined;
      this.inventoryId = _data['inventoryId'];
      this.fromRepairShopId = _data['fromRepairShopId'];
      this.toRepairShopId = _data['toRepairShopId'];
    }
  }

  static fromJS(data: any): WebOrder {
    data = typeof data === 'object' ? data : {};
    let result = new WebOrder();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['created'] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data['longitude'] = this.longitude;
    data['latitude'] = this.latitude;
    data['pickupLocation'] = this.pickupLocation;
    data['registrationNumber'] = this.registrationNumber;
    data['name'] = this.name;
    data['phoneNumber'] = this.phoneNumber;
    data['requestedDropOffLocation'] = this.requestedDropOffLocation;
    data['comment'] = this.comment;
    data['status'] = this.status;
    if (Array.isArray(this.feedbackEmails)) {
      data['feedbackEmails'] = [];
      for (let item of this.feedbackEmails) data['feedbackEmails'].push(item);
    }
    if (Array.isArray(this.feedbackSMS)) {
      data['feedbackSMS'] = [];
      for (let item of this.feedbackSMS) data['feedbackSMS'].push(item);
    }
    data['orderDate'] = this.orderDate
      ? this.orderDate.toISOString()
      : <any>undefined;
    data['inventoryId'] = this.inventoryId;
    data['fromRepairShopId'] = this.fromRepairShopId;
    data['toRepairShopId'] = this.toRepairShopId;
    return data;
  }
}

export interface IWebOrder {
  created: Date;
  longitude: number;
  latitude: number;
  pickupLocation?: string | undefined;
  registrationNumber?: string | undefined;
  name?: string | undefined;
  phoneNumber?: string | undefined;
  requestedDropOffLocation?: string | undefined;
  comment?: string | undefined;
  status?: string | undefined;
  feedbackEmails?: string[] | undefined;
  feedbackSMS?: string[] | undefined;
  orderDate?: Date | undefined;
  inventoryId?: number | undefined;
  fromRepairShopId?: number | undefined;
  toRepairShopId?: number | undefined;
}

export class RepairshopInfo implements IRepairshopInfo {
  id!: number;
  name?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  zip?: string | undefined;
  latitude!: number;
  longitude!: number;
  prioritizedEmails?: string[] | undefined;
  otherEmails?: string[] | undefined;
  phoneNumbers?: string[] | undefined;
  allEmailsString?: string | undefined;
  phoneNumbersString?: string | undefined;
  shorthandInfoString?: string | undefined;
  departmentTypes?: string[] | undefined;
  carBrands?: RepairshopInfoCarBrand[] | undefined;

  constructor(data?: IRepairshopInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.address = _data['address'];
      this.city = _data['city'];
      this.zip = _data['zip'];
      this.latitude = _data['latitude'];
      this.longitude = _data['longitude'];
      if (Array.isArray(_data['prioritizedEmails'])) {
        this.prioritizedEmails = [] as any;
        for (let item of _data['prioritizedEmails'])
          this.prioritizedEmails!.push(item);
      }
      if (Array.isArray(_data['otherEmails'])) {
        this.otherEmails = [] as any;
        for (let item of _data['otherEmails']) this.otherEmails!.push(item);
      }
      if (Array.isArray(_data['phoneNumbers'])) {
        this.phoneNumbers = [] as any;
        for (let item of _data['phoneNumbers']) this.phoneNumbers!.push(item);
      }
      this.allEmailsString = _data['allEmailsString'];
      this.phoneNumbersString = _data['phoneNumbersString'];
      this.shorthandInfoString = _data['shorthandInfoString'];
      if (Array.isArray(_data['departmentTypes'])) {
        this.departmentTypes = [] as any;
        for (let item of _data['departmentTypes'])
          this.departmentTypes!.push(item);
      }
      if (Array.isArray(_data['carBrands'])) {
        this.carBrands = [] as any;
        for (let item of _data['carBrands'])
          this.carBrands!.push(RepairshopInfoCarBrand.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RepairshopInfo {
    data = typeof data === 'object' ? data : {};
    let result = new RepairshopInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['address'] = this.address;
    data['city'] = this.city;
    data['zip'] = this.zip;
    data['latitude'] = this.latitude;
    data['longitude'] = this.longitude;
    if (Array.isArray(this.prioritizedEmails)) {
      data['prioritizedEmails'] = [];
      for (let item of this.prioritizedEmails)
        data['prioritizedEmails'].push(item);
    }
    if (Array.isArray(this.otherEmails)) {
      data['otherEmails'] = [];
      for (let item of this.otherEmails) data['otherEmails'].push(item);
    }
    if (Array.isArray(this.phoneNumbers)) {
      data['phoneNumbers'] = [];
      for (let item of this.phoneNumbers) data['phoneNumbers'].push(item);
    }
    data['allEmailsString'] = this.allEmailsString;
    data['phoneNumbersString'] = this.phoneNumbersString;
    data['shorthandInfoString'] = this.shorthandInfoString;
    if (Array.isArray(this.departmentTypes)) {
      data['departmentTypes'] = [];
      for (let item of this.departmentTypes) data['departmentTypes'].push(item);
    }
    if (Array.isArray(this.carBrands)) {
      data['carBrands'] = [];
      for (let item of this.carBrands) data['carBrands'].push(item.toJSON());
    }
    return data;
  }
}

export interface IRepairshopInfo {
  id: number;
  name?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  zip?: string | undefined;
  latitude: number;
  longitude: number;
  prioritizedEmails?: string[] | undefined;
  otherEmails?: string[] | undefined;
  phoneNumbers?: string[] | undefined;
  allEmailsString?: string | undefined;
  phoneNumbersString?: string | undefined;
  shorthandInfoString?: string | undefined;
  departmentTypes?: string[] | undefined;
  carBrands?: RepairshopInfoCarBrand[] | undefined;
}

export class RepairshopInfoCarBrand implements IRepairshopInfoCarBrand {
  name?: string | undefined;
  isAuthorized!: boolean;
  hasWarranty!: boolean;

  constructor(data?: IRepairshopInfoCarBrand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.isAuthorized = _data['isAuthorized'];
      this.hasWarranty = _data['hasWarranty'];
    }
  }

  static fromJS(data: any): RepairshopInfoCarBrand {
    data = typeof data === 'object' ? data : {};
    let result = new RepairshopInfoCarBrand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['isAuthorized'] = this.isAuthorized;
    data['hasWarranty'] = this.hasWarranty;
    return data;
  }
}

export interface IRepairshopInfoCarBrand {
  name?: string | undefined;
  isAuthorized: boolean;
  hasWarranty: boolean;
}

export class RepairShopInfoWithCustomerName
  implements IRepairShopInfoWithCustomerName
{
  customerName?: string | undefined;
  stagingLotId?: number | undefined;
  stagingLotGroupId?: number | undefined;
  repairshopInfo?: RepairshopInfo | undefined;

  constructor(data?: IRepairShopInfoWithCustomerName) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerName = _data['customerName'];
      this.stagingLotId = _data['stagingLotId'];
      this.stagingLotGroupId = _data['stagingLotGroupId'];
      this.repairshopInfo = _data['repairshopInfo']
        ? RepairshopInfo.fromJS(_data['repairshopInfo'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): RepairShopInfoWithCustomerName {
    data = typeof data === 'object' ? data : {};
    let result = new RepairShopInfoWithCustomerName();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['customerName'] = this.customerName;
    data['stagingLotId'] = this.stagingLotId;
    data['stagingLotGroupId'] = this.stagingLotGroupId;
    data['repairshopInfo'] = this.repairshopInfo
      ? this.repairshopInfo.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IRepairShopInfoWithCustomerName {
  customerName?: string | undefined;
  stagingLotId?: number | undefined;
  stagingLotGroupId?: number | undefined;
  repairshopInfo?: RepairshopInfo | undefined;
}

export class StagingLotModel implements IStagingLotModel {
  id!: number;
  customerId!: number;
  customerDisplayName?: string | undefined;
  repairShopId!: number;
  stagingLotGroupId!: number;
  timeSlots?: StagingLotTimeSlotGroupModel[] | undefined;

  constructor(data?: IStagingLotModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.customerId = _data['customerId'];
      this.customerDisplayName = _data['customerDisplayName'];
      this.repairShopId = _data['repairShopId'];
      this.stagingLotGroupId = _data['stagingLotGroupId'];
      if (Array.isArray(_data['timeSlots'])) {
        this.timeSlots = [] as any;
        for (let item of _data['timeSlots'])
          this.timeSlots!.push(StagingLotTimeSlotGroupModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StagingLotModel {
    data = typeof data === 'object' ? data : {};
    let result = new StagingLotModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['customerId'] = this.customerId;
    data['customerDisplayName'] = this.customerDisplayName;
    data['repairShopId'] = this.repairShopId;
    data['stagingLotGroupId'] = this.stagingLotGroupId;
    if (Array.isArray(this.timeSlots)) {
      data['timeSlots'] = [];
      for (let item of this.timeSlots) data['timeSlots'].push(item.toJSON());
    }
    return data;
  }
}

export interface IStagingLotModel {
  id: number;
  customerId: number;
  customerDisplayName?: string | undefined;
  repairShopId: number;
  stagingLotGroupId: number;
  timeSlots?: StagingLotTimeSlotGroupModel[] | undefined;
}

export class StagingLotTimeSlotGroupModel
  implements IStagingLotTimeSlotGroupModel
{
  id!: number;
  label?: string | undefined;
  days?: StagingLotWeekDay[] | undefined;
  startTime!: string;
  endTime!: string;

  constructor(data?: IStagingLotTimeSlotGroupModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.label = _data['label'];
      if (Array.isArray(_data['days'])) {
        this.days = [] as any;
        for (let item of _data['days']) this.days!.push(item);
      }
      this.startTime = _data['startTime'];
      this.endTime = _data['endTime'];
    }
  }

  static fromJS(data: any): StagingLotTimeSlotGroupModel {
    data = typeof data === 'object' ? data : {};
    let result = new StagingLotTimeSlotGroupModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['label'] = this.label;
    if (Array.isArray(this.days)) {
      data['days'] = [];
      for (let item of this.days) data['days'].push(item);
    }
    data['startTime'] = this.startTime;
    data['endTime'] = this.endTime;
    return data;
  }
}

export interface IStagingLotTimeSlotGroupModel {
  id: number;
  label?: string | undefined;
  days?: StagingLotWeekDay[] | undefined;
  startTime: string;
  endTime: string;
}

export enum StagingLotWeekDay {
  S = 0,
  M = 1,
  Ti = 2,
  O = 3,
  To = 4,
  F = 5,
  L = 6,
}

export class CustomerStatistics implements ICustomerStatistics {
  towingsToYouThisYear!: number;
  towingsToYouThisMonth!: number;
  incidentTypesThisYear?: IncidentType[] | undefined;
  monthReports?: TowingMonthSummary[] | undefined;

  constructor(data?: ICustomerStatistics) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.towingsToYouThisYear = _data['towingsToYouThisYear'];
      this.towingsToYouThisMonth = _data['towingsToYouThisMonth'];
      if (Array.isArray(_data['incidentTypesThisYear'])) {
        this.incidentTypesThisYear = [] as any;
        for (let item of _data['incidentTypesThisYear'])
          this.incidentTypesThisYear!.push(IncidentType.fromJS(item));
      }
      if (Array.isArray(_data['monthReports'])) {
        this.monthReports = [] as any;
        for (let item of _data['monthReports'])
          this.monthReports!.push(TowingMonthSummary.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerStatistics {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerStatistics();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['towingsToYouThisYear'] = this.towingsToYouThisYear;
    data['towingsToYouThisMonth'] = this.towingsToYouThisMonth;
    if (Array.isArray(this.incidentTypesThisYear)) {
      data['incidentTypesThisYear'] = [];
      for (let item of this.incidentTypesThisYear)
        data['incidentTypesThisYear'].push(item.toJSON());
    }
    if (Array.isArray(this.monthReports)) {
      data['monthReports'] = [];
      for (let item of this.monthReports)
        data['monthReports'].push(item.toJSON());
    }
    return data;
  }
}

export interface ICustomerStatistics {
  towingsToYouThisYear: number;
  towingsToYouThisMonth: number;
  incidentTypesThisYear?: IncidentType[] | undefined;
  monthReports?: TowingMonthSummary[] | undefined;
}

export class IncidentType implements IIncidentType {
  name?: string | undefined;
  percent!: number;
  incidentTypeIds?: number[] | undefined;

  constructor(data?: IIncidentType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.percent = _data['percent'];
      if (Array.isArray(_data['incidentTypeIds'])) {
        this.incidentTypeIds = [] as any;
        for (let item of _data['incidentTypeIds'])
          this.incidentTypeIds!.push(item);
      }
    }
  }

  static fromJS(data: any): IncidentType {
    data = typeof data === 'object' ? data : {};
    let result = new IncidentType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['percent'] = this.percent;
    if (Array.isArray(this.incidentTypeIds)) {
      data['incidentTypeIds'] = [];
      for (let item of this.incidentTypeIds) data['incidentTypeIds'].push(item);
    }
    return data;
  }
}

export interface IIncidentType {
  name?: string | undefined;
  percent: number;
  incidentTypeIds?: number[] | undefined;
}

export class TowingMonthSummary implements ITowingMonthSummary {
  year!: number;
  month!: number;
  count!: number;

  constructor(data?: ITowingMonthSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data['year'];
      this.month = _data['month'];
      this.count = _data['count'];
    }
  }

  static fromJS(data: any): TowingMonthSummary {
    data = typeof data === 'object' ? data : {};
    let result = new TowingMonthSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['year'] = this.year;
    data['month'] = this.month;
    data['count'] = this.count;
    return data;
  }
}

export interface ITowingMonthSummary {
  year: number;
  month: number;
  count: number;
}

export class UserInfo implements IUserInfo {
  id?: string | undefined;
  displayName?: string | undefined;
  phoneNumber?: string | undefined;
  email?: string | undefined;
  roles?: Role[] | undefined;
  memberOfCustomers?: CustomerPreviewModel[] | undefined;
  selectedCustomerId?: number | undefined;

  constructor(data?: IUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.displayName = _data['displayName'];
      this.phoneNumber = _data['phoneNumber'];
      this.email = _data['email'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(item);
      }
      if (Array.isArray(_data['memberOfCustomers'])) {
        this.memberOfCustomers = [] as any;
        for (let item of _data['memberOfCustomers'])
          this.memberOfCustomers!.push(CustomerPreviewModel.fromJS(item));
      }
      this.selectedCustomerId = _data['selectedCustomerId'];
    }
  }

  static fromJS(data: any): UserInfo {
    data = typeof data === 'object' ? data : {};
    let result = new UserInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['displayName'] = this.displayName;
    data['phoneNumber'] = this.phoneNumber;
    data['email'] = this.email;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item);
    }
    if (Array.isArray(this.memberOfCustomers)) {
      data['memberOfCustomers'] = [];
      for (let item of this.memberOfCustomers)
        data['memberOfCustomers'].push(item.toJSON());
    }
    data['selectedCustomerId'] = this.selectedCustomerId;
    return data;
  }
}

export interface IUserInfo {
  id?: string | undefined;
  displayName?: string | undefined;
  phoneNumber?: string | undefined;
  email?: string | undefined;
  roles?: Role[] | undefined;
  memberOfCustomers?: CustomerPreviewModel[] | undefined;
  selectedCustomerId?: number | undefined;
}

export enum Role {
  Agent = 0,
  Service = 1,
  Admin = 2,
}

export class UserInvitationModel implements IUserInvitationModel {
  id!: string;
  expirationDate!: Date;
  created!: Date;
  userEmail?: string | undefined;

  constructor(data?: IUserInvitationModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.expirationDate = _data['expirationDate']
        ? new Date(_data['expirationDate'].toString())
        : <any>undefined;
      this.created = _data['created']
        ? new Date(_data['created'].toString())
        : <any>undefined;
      this.userEmail = _data['userEmail'];
    }
  }

  static fromJS(data: any): UserInvitationModel {
    data = typeof data === 'object' ? data : {};
    let result = new UserInvitationModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['expirationDate'] = this.expirationDate
      ? this.expirationDate.toISOString()
      : <any>undefined;
    data['created'] = this.created
      ? this.created.toISOString()
      : <any>undefined;
    data['userEmail'] = this.userEmail;
    return data;
  }
}

export interface IUserInvitationModel {
  id: string;
  expirationDate: Date;
  created: Date;
  userEmail?: string | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
